import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IconSize, IconType, ModuleName } from '../../../../core-data-model';
import { TranslationService } from '../../../../translations';

@Component({
    selector: 'transaction-table-empty',
    template: `<div class="transaction-table-empty layoutCenteredColumn">
        @if (loading) {
            <loading-dots></loading-dots>
        }
        @if (!loading) {
            <div class="layoutCenteredColumn">
                <span class="icon-container">
                    <abstract-icon
                        iconType="#person-outline"
                        [iconSize]="IconSize.Big"
                    ></abstract-icon>
                    <abstract-icon
                        iconType="#checklist-simple"
                        [iconSize]="IconSize.Big"
                        style="margin-left:12px;"
                    ></abstract-icon>
                </span>
                <span
                    class="transaction-table-empty-text"
                    style="margin: 15px 0 30px;"
                    >{{
                        TR.key(
                            'subscription-manager.overview.user-activity-table.empty-fresh'
                        )
                    }}</span
                >
                @if (product === ModuleName.Unknown) {
                    <span class="transaction-table-empty-text">{{
                        TR.key(
                            'subscription-manager.overview.user-activity-table.empty-all-products'
                        )
                    }}</span>
                }
                @if (product === ModuleName.HireHero) {
                    <span class="transaction-table-empty-text">{{
                        TR.key(
                            'subscription-manager.overview.user-activity-table.empty-hire'
                        )
                    }}</span>
                }
                @if (product === ModuleName.Design2) {
                    <span class="transaction-table-empty-text">{{
                        TR.key(
                            'subscription-manager.overview.user-activity-table.empty-design'
                        )
                    }}</span>
                }
            </div>
        }
    </div>`,
    styleUrls: [
        '../overview.component.less',
        './transaction-table-empty.component.less'
    ],
    standalone: false
})
export class TransactionTableEmptyComponent implements OnChanges {
    @Input()
    product: ModuleName;
    @Input()
    loading: boolean;

    IconType = IconType;
    IconSize = IconSize;
    ModuleName = ModuleName;

    constructor(public TR: TranslationService) {}

    ngOnChanges(changes: SimpleChanges) {
        this.product = changes.product?.currentValue;
        this.loading = changes.loading?.currentValue;
    }
}
